import {CSSProperties, FC} from 'react';


export interface IIconAccelerationProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconAcceleration: FC<IIconAccelerationProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <g clipPath="url(#a)">
                <path d="M12.003 15.498a1.75 1.75 0 1 1 1.632-2.375v.001a1.75 1.75 0 0 1-1.632 2.374Zm-.004-2.5a.75.75 0 1 0 .003 1.501.75.75 0 0 0-.003-1.5Z" />
                <path d="m13.697 8.73-1.78 3.98.914.408 1.779-3.98-.913-.407ZM11.17 14.38l-.985 2.202.913.409.985-2.204-.913-.408ZM12.5 5.647h-1v2.346h1V5.647ZM7 13H4v1h3v-1ZM20 13h-3v1h3v-1ZM7.154 7.527l-.707.707 1.659 1.659.707-.707-1.66-1.66ZM16.846 7.527l-1.66 1.659.708.707 1.66-1.66-.708-.706Z" />
                <path d="M12 6a8.002 8.002 0 0 1 6.347 12.872 15.365 15.365 0 0 0-12.694 0A8 8 0 0 1 11.999 6Zm0-1a9.001 9.001 0 0 0-6.984 14.678.713.713 0 0 0 .552.265.695.695 0 0 0 .298-.067 14.36 14.36 0 0 1 12.267 0 .698.698 0 0 0 .604-.002.708.708 0 0 0 .245-.193A9.001 9.001 0 0 0 12 5Z" />
            </g>
            <defs><clipPath id="a"><path d="M0 0H18V14.943H0z" transform="translate(3 5)" /></clipPath></defs>
        </svg>
    );
};
